import React, { useEffect, useState } from "react";
import { TextField } from "../common/inputFiled";
import toast from "react-hot-toast";
import { appStorage } from "../../utils/appStorage";

export default function InvitationCode() {
    const [showModal, setShowModal] = useState(false);
    const [inviteCode, setInviteCode] = useState("");
    const [loading, setLoading] = useState(false);

    const sanitizeInvite = (s) => String(s || "").replace(/[^a-zA-Z0-9\-_.]/g, "");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const inviteFromUrl = params.get("invite") || params.get("invitation_code") || params.get("invite_code") || "";
        const inviteFromLocal = localStorage.getItem("pending_invitation_code") || "";

        if (inviteFromUrl) {
            setInviteCode(sanitizeInvite(inviteFromUrl));
            return;
        }

        if (inviteFromLocal) {
            setInviteCode(sanitizeInvite(inviteFromLocal));
        }
    }, []);

    const handleValidateCode = async () => {
        const code = sanitizeInvite(inviteCode.trim());

        if (!code) {
            return;
        }

        const email = appStorage.getItem("email") || "";

        // New flow: if user is not logged in, keep code on device and continue via login.
        if (!email) {
            localStorage.setItem("pending_invitation_code", code);
            toast.success("Invitation code saved. Please login to continue.");
            window.location.href = "/login";
            return;
        }

        setLoading(true);

        try {
            const payload = new URLSearchParams({
                invite: code,
                email: email,
            });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/invite/apply`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: payload.toString(),  // 🔥 IMPORTANT
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.removeItem("pending_invitation_code");
                toast.success("Invitation code validated successfully!");
                window.location.href = "/contact";
            } else {
                toast.dismiss();

                toast.error(data.message || "❌ Invalid invitation code.");
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };



    return (
        <div className="min-h-[var(--app-height,100dvh)] overflow-y-auto overscroll-contain bg-[#F3F0FF] flex items-start sm:items-center justify-center px-4 py-6 sm:py-8">
            <div className="w-full max-w-[520px] p-6 sm:p-8 md:p-10">
                {/* Logo + Title */}
                <div className="flex flex-col items-center gap-4 mb-8">
                    <div className="h-20 w-20 rounded-xl bg-gradient-to-br from-[#7C4DFF] to-[#6A35FF] flex items-center justify-center shadow-md">
                        <img src="./logo.svg" alt=" PhoneBookPlus Logo" />
                    </div>
                    <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-500 font-inter">
                         PhoneBookPlus
                    </h1>
                </div>

                <div className="space-y-6">
                    <div className="text-2xl text-[#475467] font-medium text-center">
                        Enter Your Invitation Code
                    </div>
                    <p className="text-[#475467] font-medium text-center">
                        Unlock exclusive access to your contacts and premium features
                    </p>

                    <div className="space-y-5">
                        <TextField
                            type="text"
                            placeholder="Enter your code"
                            value={inviteCode}
                            onChange={(e) => setInviteCode(sanitizeInvite(e.target.value))}
                            className=" submit-button w-full border border-gray-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#7C4DFF]"
                        />
                        <button
                            type="button"
                            onClick={handleValidateCode}
                                disabled={loading || !inviteCode}
                            className="submit-button flex justify-center items-center w-full bg-white text-[#6A35FF] border border-[#6A35FF] font-semibold py-3 rounded-xl hover:bg-[#F3F0FF] transition"
                        >
                            Verify Code
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm  flex items-center justify-center z-50 drop-blur-xl">
                    <div className="bg-white w-full max-w-sm p-6 rounded-2xl shadow-xl relative">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
                            Enter Invitation Code
                        </h2>

                        <TextField
                            type="text"
                            placeholder="Enter your code"
                            value={inviteCode}
                            startIcon="./input-logos/password.svg"

                            onChange={(e) => setInviteCode(sanitizeInvite(e.target.value))}
                            className=" submit-button w-full border border-gray-300 rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#7C4DFF]"
                        />
                        <div className="flex justify-between mt-6">
                            <button
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 rounded-lg text-gray-600 hover:bg-gray-100 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleValidateCode}
                                disabled={loading || !inviteCode}
                                className="submit-button px-4 bg-gradient-to-r from-[#7C4DFF] to-[#6A35FF] text-white font-semibold py-3  hover:bg-[#6A35FF] transition disabled:opacity-60 rounded-2xl shadow-md hover:opacity-90 disabled:cursor-not-allowed"
                            >
                                {loading ? "Validating..." : "Submit"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
